import { useCallback } from 'react';
import { PhieuNhapHangBanTraLai } from '@/types/schemas/phieu-nhap-hang-ban-tra-lai.type';
import { useAuth } from '@/contexts/auth-context';
import api from '@/lib/api';

interface UsePhieuNhapHangBanTraLaiReturn {
  filterPhieuNhapHangBanTraLai: (filters: Record<string, any>) => Promise<PhieuNhapHangBanTraLai[]>;
}

/**
 * Hook for managing PhieuNhapHangBanTraLai (Return Goods Receipt) data
 *
 * This hook provides functions to filter return goods receipts.
 */
export const usePhieuNhapHangBanTraLai = (): UsePhieuNhapHangBanTraLaiReturn => {
  const { entity } = useAuth();

  /**
   * Filter return goods receipts using the filter API endpoint
   */
  const filterPhieuNhapHangBanTraLai = useCallback(
    async (filters: Record<string, any>): Promise<PhieuNhapHangBanTraLai[]> => {
      if (!entity?.slug) return [];

      try {
        const response = await api.post(
          `/entities/${entity.slug}/erp/ban-hang/phieu-nhap-hang-ban-tra-lai/filter/`,
          filters
        );

        if (Array.isArray(response.data)) {
          return response.data;
        }

        if (response.data?.results) {
          return response.data.results;
        }

        return [];
      } catch (error) {
        console.error('Error filtering return goods receipts:', error);
        return [];
      }
    },
    [entity?.slug]
  );

  return {
    filterPhieuNhapHangBanTraLai
  };
};
